import { render, staticRenderFns } from "./growup-preview.vue?vue&type=template&id=2e0a714c&"
import script from "./growup-preview.vue?vue&type=script&lang=js&"
export * from "./growup-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports